import { http } from '@/core/helpers/axiosHelper';

export class EmploymentHistoryService {
   async postEmploymentHistory(employmentHistory: any) {
      return await http.post(`/employment-histories`, employmentHistory);
   }
}
